// hooks/useCountUp.js

import { useEffect, useState } from "react";

/**
 * Hook para animar un número desde 0 hasta un valor final.
 * @param {number|string} end - El valor al que se desea llegar.
 * @param {number} duration - Duración de la animación en milisegundos.
 * @returns {number} El valor actual de la animación.
 */
export const useCountUp = (end, duration = 1000) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    // Convertir a número si llega como string
    const numericEnd = typeof end === 'string' ? parseFloat(end) : end;
    
    // Validación de seguridad para JS puro
    if (isNaN(numericEnd)) {
      setValue(0);
      return;
    }

    let start = 0;
    const increment = numericEnd / (duration / 16); // ~60 fps

    const animate = () => {
      start += increment;
      if (start < numericEnd) {
        setValue(Math.floor(start));
        requestAnimationFrame(animate);
      } else {
        setValue(numericEnd);
      }
    };

    animate();
  }, [end, duration]);

  return value;
};